<template>
  <div class="rootDiv">
    <div style="border-bottom: darkgray solid 1px;background-color: black">
      <img :src="details.cPTP" style="height: 240px;margin-bottom: -0.25rem" alt="">
    </div>
    <br>
    <Span style="font-size: 1.4rem;color: green">{{ details.cPMC }}</Span>
    <br>
    <br>
    <div style="padding-left: 2rem;padding-right: 2rem;text-align: left">
      <Span>适合人数：{{ details.sHRS }}</Span>
    </div>
    <div style="padding-left: 2rem;padding-right: 2rem;text-align: left">
      <Span>准备时长：{{ details.zBSC }}</Span>
    </div>
    <div style="padding-left: 2rem;padding-right: 2rem;text-align: left">
      <Span>烹饪时长：{{ details.pRSC }}</Span>
    </div>
    <div style="padding-left: 2rem;padding-right: 2rem;text-align: left">
      <Span>所属类型：{{ details.lXMC }}</Span>
    </div>
    <br>
    <div style="padding-left: 2rem;padding-right: 2rem;text-align: left">
      <Span>特点：{{ details.cPBQ }}</Span>
    </div>
    <div v-html="details.cPPJ"
         style="padding: 2rem;text-align: left"></div>
    <div class="titleClass">
      <Span>材料</Span>
    </div>
    <ul v-for="item in details.material" :key="item.cLNM" style="background-color: #d20e2b">
      <li>
        <a class="mint-cell" style="text-align: left; padding: 0; min-height: 36px">
          <div class="mint-cell-wrapper">
            <div class="mint-cell-title" style="padding-left: 1rem;">
              <span class="mint-cell-text">{{ item.cLMC }}</span>
            </div>
            <div class="mint-cell-value" style="padding-right: 1rem"><span>
               <span class="mint-cell-text">{{ item.cLYL }}</span>
            </span>
            </div>
          </div>
          <div class="mint-cell-right"></div>
        </a>
      </li>
    </ul>
    <br>
    <div class="titleClass">
      <Span>步骤</Span>
    </div>
    <ul v-for="item in details.process" :key="item.bZNM" style="background-color: #d20e2b">
      <li>
        <a class="mint-cell" style="text-align: left; padding: 0; min-height: 40px">
          <div class="mint-cell-wrapper">
            <div class="mint-cell-title"
                 style="padding-left: 0.5rem;padding-right:0.5rem;margin-top: 1rem;padding-bottom: 1rem">
              <div>
                <div style="float: left">{{ (item.sX + 1) + '：' }}</div>
                <div v-html=" item.bZMS" class="mint-cell-text" style="font-size: 1.1rem;margin-left: 1.4rem"></div>
              </div>
              <img :src="item.bZTP" alt="" style="width: 100%;margin-top: 1rem">
            </div>
          </div>
          <div class="mint-cell-right"></div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import Recipe from "./Recipe";

export default {
  name: "RecipeDetails",
  components: {},
  data() {
    return {
      token: localStorage.getItem('token'),
      detailsRecipeUrl: '/api/otherapi/detailsRecipe',
      details: Recipe.data().recipeItem,
    }
  },
  mounted() {
    if (this.$route.params.id !== undefined) {
      let id = this.$route.params.id
      let that = this
      that.$ajax({
        method: 'get',
        url: that.detailsRecipeUrl,
        params: {id: id},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            if (!response.data.result)
              that.$messagebox.alert(response.data.message)
            else {
              that.details = response.data['responseData']
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    } else {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.rootDiv {
  margin: -0.5rem;

  ul {
    list-style-type: none;
    margin: 0;
  }
}

.titleClass {
  font-size: 1.6rem;
  color: #2986de;
  text-align: left;
  padding-left: 1.4rem;
}
</style>
